import type { Ref } from "react"

/** Imperatively write a value into a React ref, whether it's a callback ref or an object ref. */
export function assignRef<T>(ref: Ref<T> | undefined, value: T) {
  if (typeof ref === "function") ref(value)
  else if (ref) ref.current = value
}
